import {
  faAngleDown,
  faBars,
  faCartShopping,
  faCodeCompare,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import { useContext, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { CounterContext } from "../../../contexts/CounterContext";
import GeneralData from "../../../data/GeneralData.js";
import { ButtonSelect } from "../../atoms/ButtonSelect/Index.jsx";
import "../NavBar/style.css";

export const NavBar = () => {
  const { comparador, modalCar, setModalCar, setOpenBG } =
    useContext(CounterContext);

  const [openMenuSolicitud, setopenMenuSolicitud] = useState(false);
  const [openMenuCredito, setOpenMenuCredito] = useState(false);
  const [openMenuOthers, setOpenMenuOthers] = useState(false);
  const [openMenuMobile, setOpenMenuMobile] = useState(false);

  const handleMenuSolicitud = () => {
    setopenMenuSolicitud(!openMenuSolicitud);
    setOpenMenuCredito(false);
    setOpenMenuOthers(false);
  };

  const handleMenuCredito = () => {
    setOpenMenuCredito(!openMenuCredito);
    setopenMenuSolicitud(false);
    setOpenMenuOthers(false);
  };

  const handleMenuOthers = () => {
    setOpenMenuOthers(!openMenuOthers);
    setOpenMenuCredito(false);
    setopenMenuSolicitud(false);
  };

  const handleMenuMobile = () => {
    setOpenMenuMobile(!openMenuMobile);
  };

  document.addEventListener("click", (e) => {
    if (e.target.id !== "MenusNavbar") {
      setopenMenuSolicitud(false);
      setOpenMenuCredito(false);
      setOpenMenuOthers(false);
    }
  });

  const location = useLocation();

  return (
    <div id="body_container" className="c-body__container">
      <header className="c-header" id="barranav">
        <div className="g-container c-header__container">
          <div className="c-header__col">
            <Link to="/" className="c-header__logo">
              <img
                src={GeneralData.host + "images/logo-supre@2x.png"}
                alt="Logo Supremotos"
              />
            </Link>

            <div className="c-header__main-menu">
              <ul className="c-nav-1">
                <li>
                  <Link
                    to="/catalogo-de-motos"
                    className={clsx(
                      "Menus",
                      location.pathname === "/catalogo-de-motos" && "active-nav"
                    )}
                    id="MenusNavbar"
                    onClick={() => setOpenBG(false)}
                  >
                    Catálogo de motos
                  </Link>
                </li>

                {/* 🔹 Financia tu moto */}
                <li>
                  <Link
                    to="/financiamiento"
                    className={clsx(
                      "Menus",
                      location.pathname === "/financiamiento" && "active-nav"
                    )}
                    id="MenusNavbar"
                    onClick={() => setOpenBG(false)}
                  >
                    Financia tu moto
                  </Link>
                </li>

                {/* 🔹 Tu crédito */}
                <li>
                  <div
                    onClick={handleMenuCredito}
                    id="MenusNavbar"
                    className={clsx(
                      "Menus",
                      (location.pathname === "/paga-tu-cuota/" ||
                        location.pathname === "/requerimientos/") &&
                        "active-nav"
                    )}
                  >
                    Tu crédito
                    <FontAwesomeIcon className="nav-icons" icon={faAngleDown} />
                  </div>

                  <ButtonSelect
                    className={clsx(
                      "c-nav-1__submenu",
                      openMenuCredito && "open"
                    )}
                    id="submenu-tucredito"
                    setClose={setOpenMenuCredito}
                    links={[
                      { route: "/paga-tu-cuota/", name: "Paga tu cuota" },
                      { route: "/requerimientos/", name: "Requerimientos" },
                    ]}
                  />
                </li>

                {/* 🔹 Otros */}
                <li>
                  <div
                    onClick={handleMenuOthers}
                    id="MenusNavbar"
                    className={clsx(
                      "Menus",
                      (location.pathname === "/preguntas-frecuentes/" ||
                        location.pathname === "/politicas/") &&
                        "active-nav"
                    )}
                  >
                    Preguntas frecuentes
                    <FontAwesomeIcon className="nav-icons" icon={faAngleDown} />
                  </div>

                  <ButtonSelect
                    className={clsx(
                      "c-nav-1__submenu",
                      openMenuOthers && "open"
                    )}
                    id="submenu-preguntas"
                    setClose={setOpenMenuOthers}
                    links={[
                      {
                        route: "/preguntas-frecuentes/",
                        name: "Preguntas frecuentes",
                      },
                      {
                        route: "/politicas/",
                        name: "Términos y condiciones",
                      },
                    ]}
                  />
                </li>
              </ul>
            </div>
          </div>

          <div className="c-header__col colm2">
            <ul className="c-nav-1--v2">
              <li>
                <Link
                  to={
                    comparador.product.length === 0
                      ? "/comparador-de-motos/"
                      : `/comparador-de-motos/?motos=${comparador.product
                          .map((elemnt) => elemnt.id)
                          .join(",")}`
                  }
                  className="c-list4__compare icon-image-compare"
                >
                  <FontAwesomeIcon
                    className="nav-icons"
                    id="IconsRight"
                    icon={faCodeCompare}
                  />
                  <span style={{ marginLeft: "10px" }}>Comparar motos</span>
                  {comparador.product.length > 0 && (
                    <span className="c-nav-2__notify" id="count-carrito">
                      {comparador.product.length}
                    </span>
                  )}
                </Link>
              </li>

              <li>
                <div
                  className="Menus"
                  onClick={() => {
                    setModalCar((prevState) => ({
                      ...prevState,
                      state: true,
                    }));
                  }}
                >
                  <FontAwesomeIcon
                    className="nav-icons"
                    id="IconsRight"
                    icon={faCartShopping}
                    size="lg"
                  />
                  {modalCar.product.length > 0 && (
                    <span className="c-nav-2__notify" id="count-carrito">
                      {modalCar.product.length}
                    </span>
                  )}
                </div>
              </li>
            </ul>

            <div
              className="c-header__btn-mobile"
              id="open"
              onClick={handleMenuMobile}
            >
              <FontAwesomeIcon icon={faBars} />
            </div>
          </div>
        </div>
      </header>

      {/* 🔹 Menú móvil */}
      <div className={clsx("c-nav-mobile", openMenuMobile && "open")}>
        <div className="c-nav-mobile__container">
          <ul className="c-nav-3">
            {/* ✅ Motos sin submenú */}
            <li>
              <Link
                to="/catalogo-de-motos"
                className="Menus_mobile"
                id="MenusNavbar"
                onClick={handleMenuMobile}
              >
                Motos
              </Link>
            </li>

            <li>
              <div
                className="Menus_mobile"
                id="MenusNavbar"
                onClick={handleMenuSolicitud}
              >
                Solicitud de crédito
                <FontAwesomeIcon className="nav-icons" icon={faAngleDown} />
              </div>
              <ButtonSelect
                className={clsx(
                  "c-nav-3__submenu",
                  openMenuSolicitud && "open"
                )}
                id="submenu-financiamiento2"
                setClose={setOpenMenuMobile}
                links={[{ route: "/financiamiento/", name: "Moto" }]}
              />
            </li>

            <li>
              <div
                className="Menus_mobile"
                id="MenusNavbar"
                onClick={handleMenuCredito}
              >
                Tu Crédito
                <FontAwesomeIcon className="nav-icons" icon={faAngleDown} />
              </div>
              <ButtonSelect
                className={clsx("c-nav-3__submenu", openMenuCredito && "open")}
                id="submenu-tucredito3"
                setClose={setOpenMenuMobile}
                links={[
                  { route: "/paga-tu-cuota/", name: "Paga tu cuota" },
                  { route: "/requerimientos/", name: "Requerimientos" },
                ]}
              />
            </li>

            <li>
              <div
                className="Menus_mobile"
                id="MenusNavbar"
                onClick={handleMenuOthers}
              >
                Otros
                <FontAwesomeIcon className="nav-icons" icon={faAngleDown} />
              </div>
              <ButtonSelect
                className={clsx("c-nav-3__submenu", openMenuOthers && "open")}
                id="submenu-preguntas2"
                setClose={setOpenMenuMobile}
                links={[
                  {
                    route: "/preguntas-frecuentes/",
                    name: "Preguntas frecuentes",
                  },
                  {
                    route: "/general-blog/",
                    name: "Blog",
                  },
                ]}
              />
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
